<script>
    import {onMount, onDestroy, getContext} from 'svelte';
    import Util from "../../lib/util.js";

    export let width = 400;
    export let height = 400;
    export let colors = [];

    // ContributorValuation object
    export let valuations = [
        { totalContributionWorth: 0, contributorName: "You" }
    ];

    let depLoaded = false;
    let canvas = initCanvas();
    let chart;

    const options = {
        animation: {
            scale: true
        },
        responsive: true,
        legend: {
            position: 'bottom',
            labels: {
                fontColor: "#333",
                boxWidth: 20,
                padding: 20
            }
        }
    };

    let data = {
        datasets: [{
            data: [],
            backgroundColor: [],
        }],

        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: []
    };

    function totalValue() {
        return chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
    }

    function log(msg) {
        if (typeof msg === 'string')
            console.log(`[PartiPie] ${msg}`);
        else {
            console.log(msg);
        }
    }

    function initCanvas() {
        log("initializing canvas...");
        let cv = document.createElement('canvas');
        cv.width = width;
        cv.height = height;
        return cv;
    }

    function initChart() {
        log("initializing chart...");
        chart = new Chart(canvas, {
            type: 'pie',
            data: data,
            options: options
        });
    }

    function updateChart() {
        log(`updating chart with new valuation data... (#valuations: ${valuations.length})`);
        log(valuations);

        let newLabels = valuations.map(val => val.contributorName);
        let newNumbers = valuations.map(val => val.totalContributionWorth);
        let newColors = valuations.map(val => Util.guidToColor(val.contributorId, colors));

        // TODO: calc total in valuations
        // calc percentage floats
        // dispay percentages instead of value

        chart.data.labels = newLabels;
        chart.data.datasets[0] = { data: newNumbers, backgroundColor: newColors};

        // some consistency checks
        if (valuations.length) {
            if (!newLabels.length)
                throw "expected new labels to have content because valuations is not empty!";
            if (!newNumbers.length)
                throw "expected new numbers to have content because valuations is not empty!";
        }

        // the chart doesnt seem to render with 0-values
        if (totalValue() == 0) {
            chart.data.labels.push("Undivided");
            chart.data.datasets[0].data.push(1);
            chart.data.datasets[0].backgroundColor.push("#DDD");
        }

        log(newLabels);
        log(newNumbers);
        log(newColors);

        chart.update();
    }

    $: if (depLoaded) {
        log("dep loaded!");
        initChart();
        updateChart();
    }

    $: if (valuations && depLoaded) {
        updateChart();
    }

    onMount(async () => {
        log("mounting...");
        log(`has canvas: ${!!canvas}`);
        log(`has chart: ${!!chart}`);
    });
</script>

<canvas bind:this={canvas} {width} {height}/>

<svelte:head>
    <script src="https://cdn.jsdelivr.net/npm/chart.js@2.9.3/dist/Chart.min.js" on:load={() => depLoaded = true}></script>
</svelte:head>